module.exports = __webpack_public_path__ + "img/project_3.c9878a2a.png";